import { iconFactory } from '../iconFactory'

export const CloseOval = iconFactory(
  'CloseOval',
  ({ fill }) => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284Z"
      fill={fill}
    />
  ),
  { viewBox: '0 0 24 24', height: '24px', width: '24px' },
)
